import {
  all,
  takeLatest,
  call,
  put,
  select,
  race,
  take,
} from 'redux-saga/effects';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';
import { receiveQuoteItems } from 'modules/quotes/quoteItems/data/actions';

import processesService from 'services/processesService';
import quoteService from 'services/quoteService';

import { receiveQuote } from 'store/quotes/actions';
import { getFeatureFlagValue } from 'store/session/selectors';

import {
  open,
  receiveQuoteWorkflow,
  types,
  workflowStatusOverviewModal,
} from './actions';

export default function* root() {
  yield takeLatest(types.OPEN_REQUEST, watchWorkflowStatusOverviewOpen);
}

export function* watchWorkflowStatusOverviewOpen(action) {
  const { quoteId, callback } = action.payload;
  try {
    const { quote, quoteItems } = yield all({
      quote: call(quoteService.getHeaderById, quoteId),
      quoteItems: call(quoteService.getQuoteItemHeadersById, quoteId),
    });

    yield put(receiveQuote(quote));
    yield put(receiveQuoteItems(quoteItems));

    const fetchWorkflows = yield select(
      getFeatureFlagValue,
      featureFlagKeys.isWorkflowsAvailable,
    );
    if (fetchWorkflows) {
      const quoteWorkflows = yield call(processesService.workflows.list, {
        type: 'quote',
      });
      yield put(receiveQuoteWorkflow({ quoteWorkflow: quoteWorkflows[0] }));
    }
    yield put(open.success());

    const raceObject = {
      close: take(types.CLOSE),
      click: callback ? take(types.QUOTE_ITEM_CLICKED) : undefined,
    };

    const winner = yield race(raceObject);
    if (winner.click) {
      const { quoteItemId } = winner.click.payload;
      yield put(workflowStatusOverviewModal.close());
      yield call(callback, quoteItemId);
    }
  } catch (e) {
    console.error(e);
    yield put(open.error(e));
  }
}
